/*
 * File: index.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Root of Help page
 */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import HelpDesk from "./components/HelpDesk";
import ContactUs from "./components/ContactUs";
import SocialLinks from "./components/SocialLinks";

const Index = ({ appStore }) => {
  useEffect(() => {
    appStore.setTitle("Help");
    appStore.setRightNav();
  }, [appStore]);

  return (
    <React.Fragment>
      <HelpDesk />
      <ContactUs />
      <SocialLinks />
    </React.Fragment>
  );
};

Index.propTypes = {
  appStore: PropTypes.object
};

export default Index;
